import { ChangeDetectorRef, Component, Input, Output, EventEmitter, OnDestroy, OnInit, HostListener } from '@angular/core';
import { Subscription, throttleTime, asyncScheduler } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor, CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { FikoYTService } from '@/src/service/fikoyt.service';
import { FikoDialogService } from './fiko-dialog.service';

declare var $: any;

@Component({
  selector: 'fikoyt-dialog-core',
  templateUrl: './fiko-dialog-core.component.html',
  styleUrls: ['./fiko-dialog-core.component.scss'],
  imports: [CommonModule, FormsModule, OverlayModule]
})
export class FikoDialogCore implements OnDestroy {

  static pencereler: Map<string, any> = new Map();
  static aktifDialoglar: string[] = [];

  id_dialog = "FikoDialogCore" + this.FikoYT.fikoIdUret();
  /** */
  miAcik = false;
  bilesen: any;
  // İlk açılış kontrolü - konum ve genişlik sadece ilk açılışta ayarlanır
  private ilkAcilis = true;
  private responsiveAyarlandi = false;
  // Modal initialization kontrolü - modal sadece bir kez initialize edilir
  private modalBaslatildi = false;

  private _bilesenParametreler: any;
  public get bilesenParametreler(): any {
    return this._bilesenParametreler;
  }
  @Input() public set bilesenParametreler(v: any) {
    // Her seferinde yeni bir nesne oluştur ki Angular change detection tetiklensin
    // ÖNEMLI: pencere parametresini wrapper nesne ile geçir ki her açılışta farklı referans olsun
    this._bilesenParametreler = {
      ...(v ?? {}),
      pencere: { instance: this, _refreshId: Math.random() }
    };
    // console.log("🔷 DIALOG-CORE: bilesenParametreler ayarlandı, pencere wrapper oluşturuldu", {
    //   bilesenTipi: this.bilesen?.name || 'unknown',
    //   parametrelerKeyleri: Object.keys(this._bilesenParametreler),
    //   refreshId: this._bilesenParametreler.pencere._refreshId
    // });
  }

  ayarlar: any = {};

  @Output() onDialogClose = new EventEmitter<void>();

  subsDegisti: Subscription;
  /** Drag sırasında change detection'ı durdurur */
  private _surukleniyor = false;

  constructor(
    public readonly FikoYT: FikoYTService,
    public readonly CD: ChangeDetectorRef,
    private readonly dialogService: FikoDialogService
  ) {
    // 🚀 PERFORMANS: Change detection'ı 100ms throttle ile sınırla
    // Global degisti event'i saniyede onlarca kez tetiklenebilir (3D selection, import vb.)
    // Drag sırasında tamamen devre dışı bırak
    this.subsDegisti = FikoYT.degisti.pipe(
      throttleTime(100, asyncScheduler, { leading: true, trailing: true })
    ).subscribe(() => {
      if (!this._surukleniyor) {
        CD.detectChanges();
      }
    })
  }

  /**
   * ESC tuşu ile dialog kapatma
   * Semantic UI'nin kendi ESC handler'ı devre dışı (keyboardShortcuts: false)
   * Bu handler ile kontrollü kapama sağlanıyor
   * Sadece en üstteki dialog kapatılır
   */
  @HostListener('document:keydown.escape', ['$event'])
  handleEscKey(event: KeyboardEvent): void {
    // Sadece bu dialog açıksa ve en üstteki dialog bu ise kapat
    if (this.miAcik && this.dialogService.enUsttekiDialog() === this) {
      event.preventDefault();
      event.stopPropagation();
      this.kapa();
    }
  }


  public ac({ bilesen = null, ayarlar = null, parametreler = null, $event = null }) {
    // 🔄 KRITIK: Önce miAcik'i false yap ve detectChanges çağır
    // Bu, *ngIf'in child component'i yok etmesini sağlar
    // Sonra miAcik'i true yapıp tekrar detectChanges çağırarak
    // Angular'ı yeni bir component instance oluşturmaya zorlarız
    if (this.miAcik) {
      this.miAcik = false;
      this.CD.detectChanges();
    }

    // Component bilgilerini güncelle
    this.bilesen = bilesen;
    this.bilesenParametreler = parametreler ?? {};
    this.ayarlar = ayarlar ?? {};
    this.miAcik = true;

    // Hemen detectChanges çağır ki *ngIf child component'i oluştursun
    this.CD.detectChanges();

    // Modal sadece ilk seferde initialize edilir
    if (!this.modalBaslatildi) {
      // İlk initialization
      $("#" + this.id_dialog).modal({
        closable: false,
        duration: 0,
        allowMultiple: true,
        detachable: false, // Modal'ın DOM'da kalmasını sağla (yeniden açılabilmesi için kritik)
        keyboardShortcuts: false, // ESC tuşunu devre dışı bırak
        legacy: false, // 🔧 DRAGGABLE FIX: Semantic UI'nin left: 50% !important uygulayan legacy class'ını engelle
        onShow: () => {
          $("#" + this.id_dialog).parent().removeClass('dimmer');
          const self = this;
          try {
            $("#" + this.id_dialog).draggable({
              handle: ".baslikMove",
              scroll: false,
              start: function() { self._surukleniyor = true; },
              stop: function() { self._surukleniyor = false; }
            });
          } catch(e) {}
          this.miAcik = true;
        },
        onHide: () => {
          this.miAcik = false;
          // NOT: bilesen bir component CLASS'ıdır, instance değil
          // Child component'in kapa metodunu çağırmaya gerek yok
          // çünkü *ngIf ile zaten destroy edilecek
          this.CD.detectChanges();
        }
      });
      this.modalBaslatildi = true;
    }

    // 🎯 FLASH FIX: Modal'ı önce görünmez yap (opacity ile)
    const dialogElement = $("#" + this.id_dialog);
    dialogElement.css('opacity', '0');

    // Modal'ı göster
    $("#" + this.id_dialog).modal('show');

    // Konum ve genişlik ayarlama - DOM render olduktan sonra
    setTimeout(() => {
      const windowWidth = $(window).width();
      const windowHeight = $(window).height();

      // Sadece ilk açılışta veya event varsa
      if (this.ilkAcilis) {
        // İlk açılışta ekran genişliğine göre genişlik ayarla
        this.ekranGenisligineGoreAyarla(dialogElement, windowWidth, windowHeight);

        if ($event?.type == "pointerdown") {
          dialogElement.css({
            top: $event.offsetY - (dialogElement.height() || 100) / 2,
            left: $event.offsetX - (dialogElement.width() || 200) / 2
          });
        } else if ($event?.type == "touchstart") {
          dialogElement.css({
            top: $event.touches[0].pageY - (dialogElement.height() || 100) / 2,
            left: $event.touches[0].pageX - (dialogElement.width() || 200) / 2
          });
        } else {
          // Konum bilgisi yoksa ekranın merkezine yerleştir (sadece ilk açılışta)
          const dialogWidth = dialogElement.outerWidth() || 300;
          const dialogHeight = dialogElement.outerHeight() || 200;

          dialogElement.css({
            top: Math.max(0, (windowHeight - dialogHeight) / 2),
            left: Math.max(0, (windowWidth - dialogWidth) / 2)
          });
        }

        // İlk açılış tamamlandı, artık konumu ve boyutu koruyacak
        this.ilkAcilis = false;
      } else if ($event) {
        // İlk açılış değilse ama event varsa, yine event konumuna yerleştir
        if ($event?.type == "pointerdown") {
          dialogElement.css({
            top: $event.offsetY - (dialogElement.height() || 100) / 2,
            left: $event.offsetX - (dialogElement.width() || 200) / 2
          });
        } else if ($event?.type == "touchstart") {
          dialogElement.css({
            top: $event.touches[0].pageY - (dialogElement.height() || 100) / 2,
            left: $event.touches[0].pageX - (dialogElement.width() || 200) / 2
          });
        }
      }
      // Event yoksa ve ilk açılış değilse, mevcut konumunu korur (CSS ayarlanmaz)

      // Her durumda pozisyon kontrolü yap ve dimmer kaldır
      this.pozisyonKontrolEt();
      this.dimmerKaldir();

      // 🎯 FLASH FIX: Pozisyon ayarlandıktan sonra görünür yap
      dialogElement.css('opacity', '1');
    }, 50);

    this.CD.detectChanges();

  }

  /**
   * İlk açılışta ekran genişliğine göre dialog genişliğini ayarlar
   * - Küçük ekranlarda (< 640px) otomatik responsive mod
   * - Orta ekranlarda (640-1024px) %80 genişlik
   * - Büyük ekranlarda (> 1024px) mevcut genişliği korur
   */
  private ekranGenisligineGoreAyarla(dialogElement: any, windowWidth: number, windowHeight: number) {
    const minScreenWidth = 640;
    const mediumScreenWidth = 1024;

    // Mevcut dialog genişliğini al
    const mevcutGenislik = dialogElement.outerWidth() || 0;

    if (windowWidth < minScreenWidth) {
      // Küçük ekranlar - responsive mod
      const margin = 20;
      dialogElement.css({
        position: 'fixed',
        top: margin,
        left: margin,
        width: windowWidth - (margin * 2),
        height: windowHeight - (margin * 2),
        overflow: 'hidden'
      });
      this.responsiveAyarlandi = true;

      // Küçük ekranlarda draggable'ı optimize et
      this.optimizeDraggableForMobile(dialogElement);
    } else if (windowWidth < mediumScreenWidth && mevcutGenislik > windowWidth * 0.8) {
      // Orta ekranlar ve dialog çok genişse - %80 genişlik ile sınırla
      const yeniGenislik = windowWidth * 0.8;

      // Dialog'u merkeze alarak genişliği ayarla
      dialogElement.css({
        width: yeniGenislik,
        left: (windowWidth - yeniGenislik) / 2
      });
    }
    // Büyük ekranlarda mevcut genişliği koru, müdahale etme
  }

  /**
   * Draggable'ı güvenli şekilde başlatır
   * Önce mevcut instance'ı destroy eder (varsa), sonra yeniden oluşturur
   * HEM X HEM Y ekseninde hareket edebilir (axis kısıtlaması yok)
   */
  private draggableBaslat(): void {
    const dialogElement = $("#" + this.id_dialog);

    // Önce mevcut draggable'ı destroy et (varsa)
    try {
      if (dialogElement.data('ui-draggable')) {
        dialogElement.draggable('destroy');
      }
    } catch (e) {
      // Draggable yoksa hata verir, ignore et
    }

    // Yeni draggable oluştur - axis kısıtlaması YOK
    // 🚀 PERFORMANS: drag start/stop ile animasyon ve CD kontrolü
    const self = this;
    dialogElement.draggable({
      handle: ".baslikMove",
      scroll: false,
      start: function() {
        self._surukleniyor = true;
      },
      stop: function() {
        self._surukleniyor = false;
      }
    });
  }

  /**
   * Küçük ekranlar için draggable'ı optimize eder
   */
  private optimizeDraggableForMobile(dialogElement: any) {
    const currentWindowWidth = $(window).width();

    if (currentWindowWidth < 480) {
      // Çok küçük ekranlarda draggable'ı devre dışı bırak
      dialogElement.draggable('destroy');
    } else {
      // Orta küçük ekranlarda touch için optimize et
      dialogElement.draggable({
        handle: ".baslikMove",
        scroll: false,
        distance: 5,
        delay: 100,
        containment: 'window'
      });
    }
  }

  /**
   * Dialog pozisyonunu canvas/ekran sınırları içinde kontrol eder ve gerekirse düzeltir
   * - X taşmışsa → sağ kenara yasla
   * - Y taşmışsa → alt kenara yasla
   * - Her ikisi de taşmışsa → sağ alt köşeye yerleştir
   */
  private pozisyonKontrolEt() {
    const dialogElement = $("#" + this.id_dialog);
    const windowWidth = $(window).width();
    const windowHeight = $(window).height();
    const dialogWidth = dialogElement.outerWidth() || 0;
    const dialogHeight = dialogElement.outerHeight() || 0;

    // Mevcut pozisyonu al
    const currentTop = parseFloat(dialogElement.css('top')) || 0;
    const currentLeft = parseFloat(dialogElement.css('left')) || 0;

    let yeniTop = currentTop;
    let yeniLeft = currentLeft;
    let tasmaVar = false;

    // X kontrolü (sağ kenarda taşma)
    if (currentLeft + dialogWidth > windowWidth) {
      yeniLeft = windowWidth - dialogWidth - 10; // 10px margin
      tasmaVar = true;
    }

    // X kontrolü (sol kenarda taşma)
    if (currentLeft < 0) {
      yeniLeft = 10; // 10px margin
      tasmaVar = true;
    }

    // Y kontrolü (alt kenarda taşma)
    if (currentTop + dialogHeight > windowHeight) {
      yeniTop = windowHeight - dialogHeight - 10; // 10px margin
      tasmaVar = true;
    }

    // Y kontrolü (üst kenarda taşma)
    if (currentTop < 0) {
      yeniTop = 10; // 10px margin
      tasmaVar = true;
    }

    // Taşma varsa düzelt
    if (tasmaVar) {
      dialogElement.css({
        top: Math.max(10, yeniTop),
        left: Math.max(10, yeniLeft)
      });
    }
  }

  /**
   * 🎯 DIMMER POINTER-EVENTS FIX
   * Semantic UI modal dimmer'ını kaldırır veya pointer-events'i devre dışı bırakır
   * Bu sayede dialog açıkken 3D canvas üzerinde etkileşim sağlanır
   *
   * ⚠️ KRITIK: Sadece bu dialog'un parent elementlerine müdahale et
   * Global selector'lar diğer modal/menüleri bozar!
   */
  private dimmerKaldir(): void {
    const dialogEl = $("#" + this.id_dialog);
    const parentEl = dialogEl.parent();

    // 1. Parent'tan dimmer class'ını kaldır
    parentEl.removeClass('dimmer');

    // 🔧 DRAGGABLE FIX: Legacy class'ını kaldır (Semantic UI left: 50% !important sorununu çözer)
    dialogEl.removeClass('legacy');
    parentEl.removeClass('legacy');

    // 2. Sadece bu dialog'un parent container'ına stil uygula
    // 🔧 DRAGGABLE FIX: Flex centering'i devre dışı bırak
    parentEl.css({
      'pointer-events': 'none',
      'background-color': 'transparent',
      'align-items': 'flex-start',
      'justify-content': 'flex-start'
    });

    // 3. Modal kendisinin pointer-events'ini aktif tut
    // 🔧 DRAGGABLE FIX: margin auto'yu kaldır
    dialogEl.css({
      'pointer-events': 'all',
      'margin': '0'
    });
  }

  /**
   * .ui.modals.page ve .ui.dimmer sınıfına sahip boş div'leri temizler
   */
  private bosModalsTemizle() {
    $('.ui.modals.page, .ui.dimmer').each(function() {
      const $element = $(this);

      // İçeriği boş mu kontrol et (text, whitespace ve child elementler için)
      const icerik = $element.text().trim();
      const childCount = $element.children().length;

      // Eğer sadece whitespace var veya hiç child element yoksa sil
      if (icerik === '' || childCount === 0) {
        $element.remove();
      }
    });
  }

  public kapa() {
    // 🔧 GUARD: Kapalı modal'da modal('hide') çağırmak state'i bozabilir
    if (!this.miAcik) return;

    // Önce event emit et (child component cleanup'ı tetikler)
    this.onDialogClose.emit();

    this.miAcik = false;
    $("#" + this.id_dialog).modal('hide');
    // NOT: bosModalsTemizle() kaldırıldı - detachable: false ile birlikte
    // Semantic UI'nin iç yapısını bozuyordu ve modal'ların yeniden açılmasını engelliyordu
  }

  ngOnDestroy(): void {
    // $("#" + this.id_dialog).remove();
    this.subsDegisti.unsubscribe();

    // setTimeout(() => {
    //   $("#" + this.id_dialog).remove();
    // }, 100);
  }
}
